import { render, staticRenderFns } from "./DocumentListModal.vue?vue&type=template&id=d3e5fdfa"
import script from "./DocumentListModal.vue?vue&type=script&lang=js"
export * from "./DocumentListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports